import "core-js/modules/es.math.hypot.js";
import e, { PureComponent as t } from "react";

var _n = function n(e, t) {
  return (_n = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var n in t) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  })(e, t);
};

var _i = function i() {
  return (_i = Object.assign || function (e) {
    for (var t, n = 1, i = arguments.length; n < i; n++) {
      for (var r in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }).apply(this, arguments);
};

function r(e, t, n, i) {
  return new (n || (n = Promise))(function (r, a) {
    function o(e) {
      try {
        s(i.next(e));
      } catch (e) {
        a(e);
      }
    }

    function l(e) {
      try {
        s(i.throw(e));
      } catch (e) {
        a(e);
      }
    }

    function s(e) {
      var t;
      e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
        e(t);
      })).then(o, l);
    }

    s((i = i.apply(e, t || [])).next());
  });
}

function a(e, t) {
  var n,
      i,
      r,
      a,
      o = {
    label: 0,
    sent: function sent() {
      if (1 & r[0]) throw r[1];
      return r[1];
    },
    trys: [],
    ops: []
  };
  return a = {
    next: l(0),
    throw: l(1),
    return: l(2)
  }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
    return this;
  }), a;

  function l(a) {
    return function (l) {
      return function (a) {
        if (n) throw new TypeError("Generator is already executing.");

        for (; o;) {
          try {
            if (n = 1, i && (r = 2 & a[0] ? i.return : a[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, a[1])).done) return r;

            switch (i = 0, r && (a = [2 & a[0], r.value]), a[0]) {
              case 0:
              case 1:
                r = a;
                break;

              case 4:
                return o.label++, {
                  value: a[1],
                  done: !1
                };

              case 5:
                o.label++, i = a[1], a = [0];
                continue;

              case 7:
                a = o.ops.pop(), o.trys.pop();
                continue;

              default:
                if (!(r = o.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                  o = 0;
                  continue;
                }

                if (3 === a[0] && (!r || a[1] > r[0] && a[1] < r[3])) {
                  o.label = a[1];
                  break;
                }

                if (6 === a[0] && o.label < r[1]) {
                  o.label = r[1], r = a;
                  break;
                }

                if (r && o.label < r[2]) {
                  o.label = r[2], o.ops.push(a);
                  break;
                }

                r[2] && o.ops.pop(), o.trys.pop();
                continue;
            }

            a = t.call(e, o);
          } catch (e) {
            a = [6, e], i = 0;
          } finally {
            n = r = 0;
          }
        }

        if (5 & a[0]) throw a[1];
        return {
          value: a[0] ? a[1] : void 0,
          done: !0
        };
      }([a, l]);
    };
  }
}

function o(e, t, n, i) {
  e.style.transition = t + " " + n + "ms " + i;
}

function l(e, t, n) {
  return Math.min(Math.max(e, t), n);
}

var s = function s(e, t) {
  var n = this;
  this.glareAngle = 0, this.glareOpacity = 0, this.calculateGlareSize = function (e) {
    var t = e.height,
        n = Math.sqrt(Math.pow(e.width, 2) + Math.pow(t, 2));
    return {
      width: n,
      height: n
    };
  }, this.setSize = function (e) {
    var t = n.calculateGlareSize(e);
    n.glareEl.style.width = t.width + "px", n.glareEl.style.height = t.height + "px";
  }, this.update = function (e, t, i, r) {
    n.updateAngle(e, t.glareReverse), n.updateOpacity(e, t, i, r);
  }, this.updateAngle = function (e, t) {
    var i = e.xPercentage,
        r = 180 / Math.PI,
        a = i ? Math.atan2(e.yPercentage, -i) * r : 0;
    n.glareAngle = a - (t ? 180 : 0);
  }, this.updateOpacity = function (e, t, i, r) {
    var a,
        o = e.xPercentage,
        s = e.yPercentage,
        p = t.glareMaxOpacity,
        c = i ? -1 : 1,
        u = r ? -1 : 1,
        g = t.glareReverse ? -1 : 1;

    switch (t.glarePosition) {
      case "top":
        a = -o * c * g;
        break;

      case "right":
        a = s * u * g;
        break;

      case "bottom":
        a = o * c * g;
        break;

      case "left":
        a = -s * u * g;
        break;

      case "all":
        a = Math.hypot(o, s);
        break;

      default:
        a = o * c * g;
    }

    var h = l(a, 0, 100);
    n.glareOpacity = h * p / 100;
  }, this.render = function (e) {
    var t = e.glareColor;
    n.glareEl.style.transform = "rotate(" + n.glareAngle + "deg) translate(-50%, -50%)", n.glareEl.style.opacity = n.glareOpacity.toString(), n.glareEl.style.background = "linear-gradient(0deg, rgba(255,255,255,0) 0%, " + t + " 100%)";
  }, this.glareWrapperEl = document.createElement("div"), this.glareEl = document.createElement("div"), this.glareWrapperEl.appendChild(this.glareEl), this.glareWrapperEl.className = "glare-wrapper", this.glareEl.className = "glare";
  var i = {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    borderRadius: t,
    WebkitMaskImage: "-webkit-radial-gradient(white, black)"
  },
      r = this.calculateGlareSize(e),
      a = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transformOrigin: "0% 0%",
    pointerEvents: "none",
    width: r.width + "px",
    height: r.height + "px"
  };
  Object.assign(this.glareWrapperEl.style, i), Object.assign(this.glareEl.style, a);
},
    p = function p() {
  var e = this;
  this.glareAngle = 0, this.glareOpacity = 0, this.tiltAngleX = 0, this.tiltAngleY = 0, this.tiltAngleXPercentage = 0, this.tiltAngleYPercentage = 0, this.update = function (t, n) {
    e.updateTilt(t, n), e.updateTiltManualInput(t, n), e.updateTiltReverse(n), e.updateTiltLimits(n);
  }, this.updateTilt = function (t, n) {
    var i = t.yPercentage,
        r = n.tiltMaxAngleY;
    e.tiltAngleX = t.xPercentage * n.tiltMaxAngleX / 100, e.tiltAngleY = i * r / 100 * -1;
  }, this.updateTiltManualInput = function (t, n) {
    var i = n.tiltAngleXManual,
        r = n.tiltAngleYManual,
        a = n.tiltMaxAngleX,
        o = n.tiltMaxAngleY;
    (null !== i || null !== r) && (e.tiltAngleX = null !== i ? i : 0, e.tiltAngleY = null !== r ? r : 0, t.xPercentage = 100 * e.tiltAngleX / a, t.yPercentage = 100 * e.tiltAngleY / o);
  }, this.updateTiltReverse = function (t) {
    var n = t.tiltReverse ? -1 : 1;
    e.tiltAngleX = n * e.tiltAngleX, e.tiltAngleY = n * e.tiltAngleY;
  }, this.updateTiltLimits = function (t) {
    var n = t.tiltAxis;
    e.tiltAngleX = l(e.tiltAngleX, -90, 90), e.tiltAngleY = l(e.tiltAngleY, -90, 90), n && (e.tiltAngleX = "x" === n ? e.tiltAngleX : 0, e.tiltAngleY = "y" === n ? e.tiltAngleY : 0);
  }, this.updateTiltAnglesPercentage = function (t) {
    var n = t.tiltMaxAngleY;
    e.tiltAngleXPercentage = e.tiltAngleX / t.tiltMaxAngleX * 100, e.tiltAngleYPercentage = e.tiltAngleY / n * 100;
  }, this.render = function (t) {
    t.style.transform += "rotateX(" + e.tiltAngleX + "deg) rotateY(" + e.tiltAngleY + "deg) ";
  };
},
    c = _i(_i({
  scale: 1,
  perspective: 1e3,
  flipVertically: !1,
  flipHorizontally: !1,
  reset: !0,
  transitionEasing: "cubic-bezier(.03,.98,.52,.99)",
  transitionSpeed: 400,
  trackOnWindow: !1,
  gyroscope: !1
}, {
  tiltEnable: !0,
  tiltReverse: !1,
  tiltAngleXInitial: 0,
  tiltAngleYInitial: 0,
  tiltMaxAngleX: 20,
  tiltMaxAngleY: 20,
  tiltAxis: null,
  tiltAngleXManual: null,
  tiltAngleYManual: null
}), {
  glareEnable: !1,
  glareMaxOpacity: .7,
  glareColor: "#ffffff",
  glarePosition: "bottom",
  glareReverse: !1,
  glareBorderRadius: "0"
}),
    u = function (t) {
  function i() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.wrapperEl = {
      node: null,
      size: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      },
      clientPosition: {
        x: null,
        y: null,
        xPercentage: 0,
        yPercentage: 0
      },
      updateAnimationId: null,
      scale: 1
    }, e.tilt = null, e.glare = null, e.addDeviceOrientationEventListener = function () {
      return r(e, void 0, void 0, function () {
        var e;
        return a(this, function (t) {
          switch (t.label) {
            case 0:
              if (!window.DeviceOrientationEvent && "development" === process.env.NODE_ENV) return console.warn("Browser doesn't support Device Orientation."), [2];
              if (!("function" == typeof DeviceMotionEvent.requestPermission)) return [3, 4];
              t.label = 1;

            case 1:
              return t.trys.push([1, 3,, 4]), [4, DeviceOrientationEvent.requestPermission()];

            case 2:
              return "granted" === t.sent() && window.addEventListener("deviceorientation", this.onMove), [2];

            case 3:
              return e = t.sent(), console.error(e), [2];

            case 4:
              return window.addEventListener("deviceorientation", this.onMove), [2];
          }
        });
      });
    }, e.setSize = function () {
      e.setWrapperElSize(), e.glare && e.glare.setSize(e.wrapperEl.size);
    }, e.mainLoop = function (t) {
      null !== e.wrapperEl.updateAnimationId && cancelAnimationFrame(e.wrapperEl.updateAnimationId), e.processInput(t), e.update(t.type), e.wrapperEl.updateAnimationId = requestAnimationFrame(e.renderFrame);
    }, e.onEnter = function (t) {
      var n = e.props.onEnter;
      e.setSize(), e.wrapperEl.node.style.willChange = "transform", e.setTransitions(), n && n(t.type);
    }, e.onMove = function (t) {
      e.mainLoop(t), e.emitOnMove(t);
    }, e.onLeave = function (t) {
      var n = e.props.onLeave;

      if (e.setTransitions(), n && n(t.type), e.props.reset) {
        var i = new CustomEvent("autoreset");
        e.onMove(i);
      }
    }, e.processInput = function (t) {
      var n = e.props.scale;

      switch (t.type) {
        case "mousemove":
          e.wrapperEl.clientPosition.x = t.pageX, e.wrapperEl.clientPosition.y = t.pageY, e.wrapperEl.scale = n;
          break;

        case "touchmove":
          e.wrapperEl.clientPosition.x = t.touches[0].pageX, e.wrapperEl.clientPosition.y = t.touches[0].pageY, e.wrapperEl.scale = n;
          break;

        case "deviceorientation":
          e.processInputDeviceOrientation(t), e.wrapperEl.scale = n;
          break;

        case "autoreset":
          var i = e.props,
              r = i.tiltAngleYInitial / i.tiltMaxAngleY * 100;
          e.wrapperEl.clientPosition.xPercentage = l(i.tiltAngleXInitial / i.tiltMaxAngleX * 100, -100, 100), e.wrapperEl.clientPosition.yPercentage = l(r, -100, 100), e.wrapperEl.scale = 1;
      }
    }, e.processInputDeviceOrientation = function (t) {
      if (t.gamma && t.beta && e.props.gyroscope) {
        var n = e.props,
            i = n.tiltMaxAngleY,
            r = t.gamma;
        e.wrapperEl.clientPosition.xPercentage = t.beta / n.tiltMaxAngleX * 100, e.wrapperEl.clientPosition.yPercentage = r / i * 100, e.wrapperEl.clientPosition.xPercentage = l(e.wrapperEl.clientPosition.xPercentage, -100, 100), e.wrapperEl.clientPosition.yPercentage = l(e.wrapperEl.clientPosition.yPercentage, -100, 100);
      }
    }, e.update = function (t) {
      var n = e.props,
          i = n.tiltEnable,
          r = n.flipVertically,
          a = n.flipHorizontally;
      "autoreset" !== t && "deviceorientation" !== t && "propChanged" !== t && e.updateClientInput(), i && e.tilt.update(e.wrapperEl.clientPosition, e.props), e.updateFlip(), e.tilt.updateTiltAnglesPercentage(e.props), e.glare && e.glare.update(e.wrapperEl.clientPosition, e.props, r, a);
    }, e.updateClientInput = function () {
      var t, n;

      if (e.props.trackOnWindow) {
        var i = e.wrapperEl.clientPosition,
            r = i.x;
        t = i.y / window.innerHeight * 200 - 100, n = r / window.innerWidth * 200 - 100;
      } else {
        var a = e.wrapperEl,
            o = a.size,
            s = a.clientPosition;
        t = (s.y - o.top) / o.height * 200 - 100, n = ((r = s.x) - o.left) / o.width * 200 - 100;
      }

      e.wrapperEl.clientPosition.xPercentage = l(t, -100, 100), e.wrapperEl.clientPosition.yPercentage = l(n, -100, 100);
    }, e.updateFlip = function () {
      var t = e.props,
          n = t.flipHorizontally;
      t.flipVertically && (e.tilt.tiltAngleX += 180, e.tilt.tiltAngleY *= -1), n && (e.tilt.tiltAngleY += 180);
    }, e.renderFrame = function () {
      e.resetWrapperElTransform(), e.renderPerspective(), e.tilt.render(e.wrapperEl.node), e.renderScale(), e.glare && e.glare.render(e.props);
    }, e;
  }

  return function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

    function i() {
      this.constructor = e;
    }

    _n(e, t), e.prototype = null === t ? Object.create(t) : (i.prototype = t.prototype, new i());
  }(i, t), i.prototype.componentDidMount = function () {
    this.tilt = new p(), this.initGlare(), this.addEventListeners();
    var e = new CustomEvent("autoreset");
    this.mainLoop(e);
    var t = new CustomEvent("initial");
    this.emitOnMove(t);
  }, i.prototype.componentWillUnmount = function () {
    null !== this.wrapperEl.updateAnimationId && cancelAnimationFrame(this.wrapperEl.updateAnimationId), this.removeEventListeners();
  }, i.prototype.componentDidUpdate = function () {
    var e = new CustomEvent("propChanged");
    this.mainLoop(e);
  }, i.prototype.addEventListeners = function () {
    var e = this.props,
        t = e.trackOnWindow,
        n = e.gyroscope;
    window.addEventListener("resize", this.setSize), t && (window.addEventListener("mouseenter", this.onEnter), window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseout", this.onLeave), window.addEventListener("touchstart", this.onEnter), window.addEventListener("touchmove", this.onMove), window.addEventListener("touchend", this.onLeave)), n && this.addDeviceOrientationEventListener();
  }, i.prototype.removeEventListeners = function () {
    var e = this.props,
        t = e.trackOnWindow,
        n = e.gyroscope;
    window.removeEventListener("resize", this.setSize), t && (window.removeEventListener("mouseenter", this.onEnter), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseout", this.onLeave), window.removeEventListener("touchstart", this.onEnter), window.removeEventListener("touchmove", this.onMove), window.removeEventListener("touchend", this.onLeave)), n && window.DeviceOrientationEvent && window.removeEventListener("deviceorientation", this.onMove);
  }, i.prototype.setWrapperElSize = function () {
    var e = this.wrapperEl.node.getBoundingClientRect();
    this.wrapperEl.size.width = this.wrapperEl.node.offsetWidth, this.wrapperEl.size.height = this.wrapperEl.node.offsetHeight, this.wrapperEl.size.left = e.left + window.scrollX, this.wrapperEl.size.top = e.top + window.scrollY;
  }, i.prototype.initGlare = function () {
    var e = this.props;
    e.glareEnable && (this.glare = new s(this.wrapperEl.size, e.glareBorderRadius), this.wrapperEl.node.appendChild(this.glare.glareWrapperEl));
  }, i.prototype.emitOnMove = function (e) {
    var t = this.props.onMove;

    if (t) {
      var n = 0,
          i = 0;
      this.glare && (n = this.glare.glareAngle, i = this.glare.glareOpacity), t(this.tilt.tiltAngleX, this.tilt.tiltAngleY, this.tilt.tiltAngleXPercentage, this.tilt.tiltAngleYPercentage, n, i, e.type);
    }
  }, i.prototype.resetWrapperElTransform = function () {
    this.wrapperEl.node.style.transform = "";
  }, i.prototype.renderPerspective = function () {
    this.wrapperEl.node.style.transform += "perspective(" + this.props.perspective + "px) ";
  }, i.prototype.renderScale = function () {
    var e = this.wrapperEl.scale;
    this.wrapperEl.node.style.transform += "scale3d(" + e + "," + e + "," + e + ")";
  }, i.prototype.setTransitions = function () {
    var e = this.props,
        t = e.transitionSpeed,
        n = e.transitionEasing;
    o(this.wrapperEl.node, "all", t, n), this.glare && o(this.glare.glareEl, "opacity", t, n);
  }, i.prototype.render = function () {
    var t = this,
        n = this.props;
    return e.createElement("div", {
      ref: function ref(e) {
        return t.wrapperEl.node = e;
      },
      onMouseEnter: this.onEnter,
      onMouseMove: this.onMove,
      onMouseLeave: this.onLeave,
      onTouchStart: this.onEnter,
      onTouchMove: this.onMove,
      onTouchEnd: this.onLeave,
      className: n.className,
      style: n.style
    }, n.children);
  }, i.defaultProps = c, i;
}(t);

export default u;